import { Component, h } from 'preact';

class TcrTagsClass
{
    constructor() 
    {
        this.state = {
            contact_combinations: [],
            contact_tags: [], 
            task_combinations: [],
            task_tags: [], 
            doc_combinations: [],
            doc_tags: [],
            issue_combinations: [],
            issue_tags: [],
            tags: []
        };

        this.availableTags = [];
        // TcrStore.subscribe('data.contacts', this.contactsUpdated.bind(this));
        // TcrStore.subscribe('data.tasks', this.tasksUpdated.bind(this));
        // TcrStore.subscribe('data.docs', this.docsUpdated.bind(this));
        // TcrStore.subscribe('data.issues', this.issuesUpdated.bind(this));
    }

    createIndex(rows)
    {
        let index = {};
        for (let key in rows)
        {
            if (rows[key].meta && Array.isArray(rows[key].meta.tags))
            {
                for (let tag of rows[key].meta.tags)
                {
                    if (!index.hasOwnProperty(tag)) index[tag] = [];
                    index[tag].push(key);
                }
            }
        }
        //console.log('createIndex', index, rows);
        return index;
    }

    extract(items)
    {
        let tags = [];
        for (let key in items)
        {
            if (items[key].hasOwnProperty('meta') && items[key].meta.hasOwnProperty('tags') && Array.isArray(items[key].meta.tags))
            {
                tags.push(...items[key].meta.tags);
            }
        }
        this.availableTags = tags.filter((value, index, self) => {
            return self.indexOf(value) === index;
        });
    }

    filter(tags, index, id)
    {
        for (let tag of tags)
        {
            if (index.hasOwnProperty(tag) && index[tag].indexOf(id) < 0) return false;
        }
        //console.log('filter', tags, index, id);

        return true;
    }

    contactsUpdated(data)
    {
        let items = data ? Object.values(data) : [];
        let tags = [];
        let combinations = {};
        for (let i = 0; i < items.length; i++)
        {
            if (Array.isArray(items[i].tags))
            {
                this.getCombinations(combinations, items[i].tags);
                for (let j = 0; j < items[i].tags.length; j++)
                {
                    let tag = items[i].tags[j].trim();
                    if (tags.indexOf(tag) < 0)
                    {
                        tags.push(tag);
                    }
                }
            }
        }
        this.state.contact_combinations = combinations;
        this.state.contact_tags = tags;
    }

    tasksUpdated(data)
    {
        let items = data ? Object.values(data) : [];
        let tags = [];
        let combinations = {};
        for (let i = 0; i < items.length; i++)
        {
            if (Array.isArray(items[i].tags))
            {
                this.getCombinations(combinations, items[i].tags);
                for (let j = 0; j < items[i].tags.length; j++)
                {
                    let tag = items[i].tags[j].trim();
                    if (tags.indexOf(tag) < 0)
                    {
                        tags.push(tag);
                    }
                }
            }
        }
        this.state.task_combinations = combinations;
        this.state.task_tags = tags;
    }

    docsUpdated(data)
    {
        let items = data ? Object.values(data) : [];
        let tags = [];
        let combinations = {};
        for (let i = 0; i < items.length; i++)
        {
            if (Array.isArray(items[i].tags))
            {
                this.getCombinations(combinations, items[i].tags);
                for (let j = 0; j < items[i].tags.length; j++)
                {
                    let tag = items[i].tags[j].trim();
                    if (tags.indexOf(tag) < 0)
                    {
                        tags.push(tag);
                    }
                }
            }
        }
        this.state.doc_combinations = combinations;
        this.state.doc_tags = tags;
    }

    issuesUpdated(data)
    {
        let items = data ? Object.values(data) : [];
        let tags = [];
        let combinations = {};
        for (let i = 0; i < items.length; i++)
        {
            if (Array.isArray(items[i].tags))
            {
                this.getCombinations(combinations, items[i].tags);
                for (let j = 0; j < items[i].tags.length; j++)
                {
                    let tag = items[i].tags[j].trim();
                    if (tags.indexOf(tag) < 0)
                    {
                        tags.push(tag);
                    }
                }
            }
        }
        this.state.issue_combinations = combinations;
        this.state.issue_tags = tags;
    }

    getCombinations(result, array)
    {
        for (let i = 0; i < array.length; i++)
        {
            let tag = array[i];
            if (!result.hasOwnProperty(tag)) result[tag] = [];
            for (let j = 0; j < array.length; j++)
            {
                if (i != j && result[tag].indexOf(array[j]) < 0)
                {
                    result[tag].push(array[j]);
                }
            }
        }
    }

    findPossibilities(combinations, array)
    {
        let result = [];
        if (array.length > 0 && combinations.hasOwnProperty(array[0]))
        {
            result = combinations[array[0]];
            for (let i = 1; i < array.length; i++)
            {
                if (combinations.hasOwnProperty(array[i]))
                {
                    result = result.filter((e) => {
                        return combinations[array[i]].includes(e);
                    });
                }
            }
        }
        return result;
    }

    getSuggestions(currentTags, query)
    {
        let suggestions = [];
        let lquery = query.toLowerCase().trim();
        suggestions = this.availableTags.filter((t) => { 
            return !lquery || t.toLowerCase().indexOf(lquery) >= 0; 
        });
        suggestions.sort((a, b) => {
            if (a.toLowerCase().indexOf(lquery) < b.toLowerCase().indexOf(lquery))
            {
                return -1;
            }
            else if (a.toLowerCase().indexOf(lquery) > b.toLowerCase().indexOf(lquery))
            {
                return 1;
            }
            else if (a.toLowerCase() < b.toLowerCase())
            {
                return -1;
            }
            else if (a.toLowerCase() > b.toLowerCase())
            {
                return 1;
            }
            return 0;
        });
        return suggestions.filter((t)=> {
            return currentTags.indexOf(t) == -1;
        });
    }

    /**
     * 
     * @param {*} tags search for these tags 
     * @param {*} tags2 in these tags
     * @param {*} matches 
     */
    getTagScore(tags, tags2, matches)
    {
        let score = 0;
        if (Array.isArray(tags) && Array.isArray(tags2))
        {
            let tagsA = tags.map((t) => {
                return t.split('/').map((_t, i, subtags) => {
                    return subtags.slice(0, i + 1).join('/');
                });
            }).flat().filter((value, index, self) => {
                //only unique items
                return self.indexOf(value) === index;
            });
            let tagsB = tags2.map((t) => {
                return t.split('/').map((_t, i, subtags) => {
                    return subtags.slice(0, i + 1).join('/');
                });
            }).flat().filter((value, index, self) => {
                //only unique items
                return self.indexOf(value) === index;
            });
            for (let i = 0; i < tagsA.length; i++)
            {
                if (tagsB.indexOf(tagsA[i]) >= 0)
                {
                    score++;
                    if (Array.isArray(matches)) {
                        matches.push(tagsA[i]);
                    }
                }
            }
        }
        return score;
    }

    match(tags, tags2)
    {
        if (Array.isArray(tags) && Array.isArray(tags2) && tags.length == tags2.length)
        {
            for (let i = 0; i < tags.length; i++)
            {
                if (tags2.indexOf(tags[i]) < 0) return false;
            }
            return true;
        }
        return false;
    }

    getTagOptions(currentTags, onlyExistingCombinations = false)
    {
        let tags = [];
        if (onlyExistingCombinations && currentTags.length > 0)
        {
            tags = [
                ...this.findPossibilities(this.state.contact_combinations, currentTags),
                ...this.findPossibilities(this.state.task_combinations, currentTags),
                ...this.findPossibilities(this.state.doc_combinations, currentTags),
                ...this.findPossibilities(this.state.issue_combinations, currentTags)
            ].filter((value, index, self) => {
                //only unique items
                return self.indexOf(value) === index;
            });
        }
        else
        {
            tags = [
                ...this.state.contact_tags,
                ...this.state.task_tags,
                ...this.state.doc_tags,
                ...this.state.issue_tags
            ].map((t) => {
                return t.split('/').map((_t, i, subtags) => {
                    return subtags.slice(0, i + 1).join('/');
                });
            }).flat().filter((value, index, self) => {
                //only unique items
                return self.indexOf(value) === index;
            }).filter((value) => {
                return currentTags.indexOf(value) < 0;
            });
        }
        tags.sort();
        return tags.map(t => {
            return {key: t, value: t};
        });
    }

    collect(target, source)
    {
        for (let i = 0; Array.isArray(source) && i < source.length; i++)
        {
            for (let j = 0; Array.isArray(source[i].tags) && j < source[i].tags.length; j++)
            {
                if (target.indexOf(source[i].tags[j]) < 0)
                {
                    target.push(source[i].tags[j]);
                }
            }
        }
    }

    getRelatedTags(selectedTags, poolOfTags)
    {
        let showOnlyTopLevel = selectedTags.length === 0 && !Array.isArray(poolOfTags);
        
        if (!Array.isArray(poolOfTags))
        {
            poolOfTags = [
                ...this.state.contact_tags,
                ...this.state.task_tags,
                ...this.state.doc_tags,
                ...this.state.issue_tags
            ];
        }

        poolOfTags = this.forIndex(poolOfTags).filter((tag) => {
            return true; //selectedTags.indexOf(tag) < 0;
        });
        //console.log('showOnlyTopLevel:', showOnlyTopLevel, poolOfTags);

        return poolOfTags.filter((tag) =>
        {
            if (tag.indexOf('/') >= 0)
            {
                if (showOnlyTopLevel) return false;
                let parent = tag.substring(0, tag.lastIndexOf('/'));
                return selectedTags.indexOf(parent) >= 0;
            }
            return true;
        }).sort((a,b) => {
            let a_base = a.indexOf('/') === -1 ? a : a.substring(0, a.indexOf('/'));
            let b_base = b.indexOf('/') === -1 ? b : b.substring(0, b.indexOf('/'));
            if (selectedTags.indexOf(a_base) >= 0 && selectedTags.indexOf(b_base) < 0) return -1;
            if (selectedTags.indexOf(a_base) < 0 && selectedTags.indexOf(b_base) >= 0) return 1;
            let a_parent = a.substring(0, a.lastIndexOf('/'));
            let b_parent = b.substring(0, b.lastIndexOf('/'));
            if (a_parent && a_parent == b_parent)
            {
                if (selectedTags.indexOf(a) >= 0 && selectedTags.indexOf(b) < 0) return -1;
                if (selectedTags.indexOf(a) < 0 && selectedTags.indexOf(b) >= 0) return 1;
            }
            return a.localeCompare(b);
            //return a.substring(a.lastIndexOf('/') + 1).localeCompare(b.substring(b.lastIndexOf('/') + 1));
        });
    }

    forIndex(tags)
    {
        if (!Array.isArray(tags)) return [];
        let x = tags.map(tag => {
            //if (toLowerCase) tag = tag.replace(/ü/g, 'ue').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/Ü/g, 'Ue').replace(/Ä/g, 'Ae').replace(/Ö/g, 'Oe').replace(/ß/g, 'ss');
            let results = [tag];
            let parent = tag.substring(0, tag.lastIndexOf('/'));
            while (parent)
            {
                results.push(parent);
                parent = parent.substring(0, parent.lastIndexOf('/'));
            }
            return results;
        }).flat().filter((value, index, self) => {
            //only unique items
            return self.indexOf(value) === index;
        }).sort();
        return x;
    }

    forFilter(tags)
    {
        return tags.filter((value, index, self) => {
            for (let i = 0; i < self.length; i++)
            {
                if (i !== index && self[i] && self[i].length > value.length && self[i].substr(value.length, 1) == '/' && self[i].substr(0, value.length) == value) return false;
            }
            return true;
        });
    }

    renderNicely(t)
    {
        if (t.indexOf('/') === -1) return t;
        return t.replace(/\//g, '/_sep_/').split('/').map(t => {
            return t == '_sep_' ? <span>/</span> : t;
        });
    }

    test1(singleTag, listOfTags)
    {
        //return true if the single tag is in listOfTags or any of the list startswith singletag
        if (Array.isArray(listOfTags) && listOfTags.length > 0)
        {
            for (const x of listOfTags)
            {
                if (x == singleTag) 
                {
                    return true;
                }
                if (x.length > singleTag.length && x.substr(singleTag.length, 1) == '/' && x.substr(0, singleTag.length) == singleTag)
                {
                    return true;
                }
            }
        }
        return false;
    }

    // filter(query, data)
    // {
    //     const results = {};
    //     if (query.tags.length)
    //     {
    //         const queryTags = this.forFilter(query.tags);
    //         outer:
    //         for (const key in data)
    //         {
    //             for (const q of queryTags)
    //             {
    //                 if (this.test1(q, data[key].tags) == false) continue outer; 
    //             }
    //             results[key] = data[key];
    //         }
    //     }
    //     return results;
    // }
}
const TcrTags = new TcrTagsClass();
export { TcrTags };